// @ngInject
function stateConfig($stateProvider) {
    $stateProvider.state('product.variantgroups.new', {
        url: '/new',
        views: {
            "productView@product": {
                templateUrl: 'main/product/variantgroups/variantgroup/variantgroup.tpl.html',
                controller: 'VariantGroupController as vm'
            }
        },
        resolve: {
            createNew: function() {
                return true;
            },
            variantGroup: function() {
                return {
                    groupName: '',
                    variantDetails: []
                };
            },
            variants: variantResolver
        }
    });
    $stateProvider.state('product.variantgroups.variantgroup', {
        url:'/{variantGroupId}',
        views: {"productView@product": {
            templateUrl: 'main/product/variantgroups/variantgroup/variantgroup.tpl.html',
            controller: 'VariantGroupController as vm'
        }},
        resolve: {
            createNew: function() {
                return false;
            },
            variantGroup: variantGroupResolver,
            variants: function() { return []; }
        }
    });
}

// @ngInject
function variantGroupResolver($stateParams, VariantGroupsApiService) {
    return VariantGroupsApiService.getVariantGroup($stateParams.variantGroupId);
}

// @ngInject
function variantResolver($stateParams, VariantGroupsApiService) {
    return VariantGroupsApiService.getVariantBriefs();
}

// @ngInject
function VariantGroupController($state, $scope, createNew, variantGroup, variants, loadSpinnerService, VariantGroupsApiService) {
    var vm = this;

    //Properties
    vm.variantGroupCopy = {};
    vm.variantGroup = variantGroup;
    vm.isEditing = false;
    vm.isNew = false;
    vm.variantDetails = [];
    vm.variants = variants;
    vm.selectedVariant = {};
    vm.orgDetails = [];
    vm.addedVariantDetails = [];

    //Methods
    vm.enableEditing = enableEditing;
    vm.cancelEditing = cancelEditing;
    vm.saveVariantGroup = saveVariantGroup;
    vm.isAllInformationValid = isAllInformationValid;
    //vm.moveUpward = moveUpward;
    //vm.moveDownward = moveDownward;
    vm.removeVariantDetail = removeVariantDetail;
    vm.loadVariantDetails = loadVariantDetails;

    vm.devFeaturesEnabled = localStorage.getItem('devFeature_reactVariantGroupView') !== 'false';

    if (createNew) {
        vm.isNew = true;
        vm.isEditing = true;
    }

    activate();

    function activate() {
        loadVariantDetails();

        $scope.$watch(function() { return vm.selectedVariant; }, function(newValue, oldValue) {
            if (newValue !== oldValue) {
                loadVariantDetails();
            }
        });
    }

    function loadVariantDetails() {
        var variantId = null;
        if (vm.isNew) {
            if (vm.selectedVariant && vm.selectedVariant.id) {
                variantId = vm.selectedVariant.id;
            } else {
                return;
            }
        } else {
            variantId = vm.variantGroup.variant.id;
        }
        loadSpinnerService.start('mainSpinner');
        VariantGroupsApiService.getVariantDetails(variantId).then(function(response) {
            vm.variantDetails = response;
            vm.addedVariantDetails = [];
        }, function(error) {
            console.log(error);
        }).then(function() {
            loadSpinnerService.stop('mainSpinner');
        });
    }

    // function moveUpward(variantDetail) {
    //     var index = vm.variantGroup.variantDetails.indexOf(variantDetail);
    //     if (index === 0) { return; }
    //     var prev = vm.variantGroup.variantDetails[index - 1];
    //     var tempSortOrder = variantDetail.sortOrder;
    //     variantDetail.sortOrder = prev.sortOrder;
    //     prev.sortOrder = tempSortOrder;
    // }
    // function moveDownward(variantDetail) {
    //     var index = vm.variantGroup.variantDetails.indexOf(variantDetail);
    //     if (index === vm.variantGroup.variantDetails.length - 1) { return; }
    //     var next = vm.variantGroup.variantDetails[index + 1];
    //     var tempSortOrder = variantDetail.sortOrder;
    //     variantDetail.sortOrder = next.sortOrder;
    //     next.sortOrder = tempSortOrder;
    // }

    function removeVariantDetail(variantDetail) {
        var index = vm.variantGroup.variantDetails.indexOf(variantDetail);

        vm.variantGroup.variantDetails.splice(index, 1);
    }

    function enableEditing() {
        vm.variantGroupCopy = angular.copy(vm.variantGroup);
        vm.isEditing = true;
    }

    function cancelEditing() {
        vm.variantGroup = vm.variantGroupCopy;
        vm.isEditing = false;
        vm.addedVariantDetails = [];
    }

    function saveVariantGroup() {
        vm.variantGroup.variantDetails = _.unionWith(vm.variantGroup.variantDetails, vm.addedVariantDetails, _.isEqual);

        if (vm.isNew) {
            vm.variantGroup.variant = { id: vm.selectedVariant.id };
        }

        updateVariantGroup();
    }

    function updateVariantGroup() {
        loadSpinnerService.start('mainSpinner');
        VariantGroupsApiService.saveVariantGroup(vm.variantGroup).then(function(response) {
            vm.variantGroup = response;
            vm.isEditing = false;
            vm.isNew = false;
            vm.addedVariantDetails = [];
        }, function(error) {
            console.log(error);
        }).finally(function() {
            loadSpinnerService.stop('mainSpinner');
            if (vm.variantGroup.id) {
                $state.go('product.variantgroups.variantgroup', { variantGroupId: vm.variantGroup.id });
            }
        });
    }

    function isAllInformationValid() {
        if (vm.variantGroup.groupName.length === 0) {
            return false;
        }
        if (vm.isNew && vm.addedVariantDetails.length === 0) {
            return false;
        }
        if (!vm.isNew && vm.variantGroup.variantDetails.length === 0) {
            return false;
        }

        return true;
    }

}

angular
    .module('product.variantgroups.variantgroup', [])
    .config(stateConfig)
    .controller('VariantGroupController', VariantGroupController);
